import React from "react";

const styles = `
html, body, #root {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

body::before {
  content: "";
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background-image: url('https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1470&q=80');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: brightness(0.75);
  z-index: -1;
}

.page-container {
  position: relative;
  z-index: 1;
  max-width: 1000px;
  margin: 90px auto;
  padding: 190px 110px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  box-shadow: 0 0 15px rgba(0,0,0,0.2);
  box-sizing: border-box;
}

.page-container h2 {
  margin-bottom: 8px;
  color: #222;
}

.page-container h3 {
  margin-top: 25px;
  margin-bottom: 10px;
  color: #333;
}

.page-container p,
.page-container li {
  font-size: 16px;
  line-height: 1.6;
  color: #444;
}

.page-container ul {
  list-style-type: disc;
  margin-left: 20px;
  padding-left: 0;
}
`;

const CV = () => {
  React.useEffect(() => {
    const styleTag = document.createElement("style");
    styleTag.textContent = styles;
    document.head.appendChild(styleTag);
    return () => document.head.removeChild(styleTag);
  }, []);

  return (
    <div className="page-container">
      <h2>Dhvaj Arvindbhai Patel</h2>
      <p>📞 8780517670 | ✉ pdhvaj58@gmail.com</p>

      <h3>Professional Summary</h3>
      <p>
        Passionate about me, I become a Data Scientist. Looking for
        opportunities to apply my knowledge in Web-Development.
      </p>

      <h3>Education</h3>
      <p>(Hons.) B.SC. Data Science & Artificial Intelligence — IAR University</p>
      <p>GPA: 7.76</p>

      <h3>Skills</h3>
      <ul>
        <li>Python, C++, SQL, React-JS</li>
        <li>Turbo C++, Jupyter Notebook, MySQL, VS Code</li>
      </ul>

      <h3>Projects</h3>
      <p>Created a personal website using React.js</p>

      <h3>Certifications</h3>
      <ul>
        <li>Data Science — Great Learning</li>
        <li>Statistics — Great Learning</li>
        <li>Data Structure — Simplilearn</li>
      </ul>

      <h3>Other</h3>
      <p>I am CR in My Classroom | Language: English</p>
    </div>
  );
};

export default CV;
